"use client";

import type Shape from "@tosize/shapes/src/lib/models/Shape";
import type { ThreeInputLinesType, ThreeSidePathsType } from "@tosize/shapes/src/types/three";
import type { Workpiece } from "@tosize/shapes/src/types/workpiece";
import { createContext, useContext } from "react";
import type { ExtendedVisuProps } from ".";

interface PanelVisualisationInterface
	extends Pick<ExtendedVisuProps, "lang" | "shape" | "workpiece"> {
	dimensions?: Workpiece["shape_dimensions"];
	isModified: boolean;
	shapeModel?: Shape;
	sidePaths?: ThreeSidePathsType[];
	inputLines?: ThreeInputLinesType[];
	dimensionsString?: string;
	length: number;
	width: number;
	thickness: number;
}

export const PanelVisualisationContext = createContext<PanelVisualisationInterface>(
	{} as PanelVisualisationInterface,
);

export function usePanelVisualisation() {
	const context = useContext(PanelVisualisationContext);

	if (context === null) throw new Error("PanelVisualisation context is not available");

	return context;
}
